import { getCookie } from '@/store/authenticationProvider/cookies';
import type { ProfileField } from './types';

export const careDefaults = (fields: readonly ProfileField[], now = new Date()): Record<string, string> => {
  const date = Object.fromEntries(new Intl.DateTimeFormat('en-US', { timeZone: 'America/Los_Angeles', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(now).map(part => [part.type, part.value]));
  const preferred = getCookie('preferredServiceType') ?? '';
  return { service_date: `${date.year}-${date.month}-${date.day}`, service_type: fields.find(field => field.name === 'service_type')?.options.includes(preferred) ? preferred : '' };
};

export const carePresentation = {
  lengths: ['15', '30', '45', '60', '75', '90', '105', '120', '150', '180', '210', '240'],
  labels: {
    service_date: 'Service date', service_type: 'Service type', procedure_length: 'Procedure length (minutes)',
    procedure_note: 'Procedure note', billing_proceduremod1: 'In person / Telehealth',
    billing_proceduremod2: 'Clinical / Nonclinical', place_of_service: 'Place of service',
  } as Record<string, string>,
  choices: {
    home: 'Home', office: 'Office', telehealth_home: 'Telehealth in participant home',
    telehealth_outside: 'Telehealth outside participant home', in_person: 'In person',
    telehealth: 'Telehealth', clinical: 'Clinical', nonclinical: 'Nonclinical',
  } as Record<string, string>,
};
